module.exports = __webpack_public_path__ + "static/media/samurai.3f0692fb.png";